/**
 * Carrega o dataset do CRM uma vez por tela e separa carregando / erro / dado
 * (Task 13). Mesmo papel do `DatasetBoundary`, do `CatalogBoundary` e do
 * `OrdersBoundary`: nenhuma tela de CRM repete essa lógica nem confunde erro de
 * carga com "cliente sem relacionamento".
 *
 * Migrado para `.tsx`/JSX real (Cluster C — Atendimento & CRM, redesign por
 * perfil; ver `docs/architecture/ADR-0011-*.md`). Mudança de sintaxe apenas
 * (`createElement` → JSX): este componente delega todo ícone ao `StatusPanel`
 * (loading/error/empty já carregam ícone próprio) — nenhum ícone novo aqui.
 */
// Import explícito de `React` — ver o comentário equivalente em `AppShell.tsx`
// (necessário para `tsx --test`, o motor de `npm test`).
import React, { type ReactElement } from "react";
import { StatusPanel, errorDetail } from "./StatusPanel.js";
import { useCrmDataset } from "../queries.js";
import type { CrmDataset } from "../crm/dataset.js";

export interface CrmBoundaryProps {
  children: (dataset: CrmDataset) => ReactElement;
}

export function CrmBoundary({ children }: CrmBoundaryProps): ReactElement {
  const query = useCrmDataset();
  if (query.isPending) {
    return <StatusPanel kind="loading" title="Carregando relacionamento, pipeline e propostas…" />;
  }
  if (query.error) {
    return <StatusPanel kind="error" title="Não foi possível carregar o CRM" detail={errorDetail(query.error)} />;
  }
  if (!query.data) {
    return <StatusPanel kind="empty" title="Nenhum dado de CRM retornado pela API da Plataforma" />;
  }
  return children(query.data);
}
